// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  snapshotId: __t.string().primaryKey().name("snapshot_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  armyIndex: __t.u32().name("army_index"),
  tick: __t.u32(),
  phase: __t.string(),
  followActive: __t.bool().name("follow_active"),
  columnEventsJson: __t.option(__t.string()).name("column_events_json"),
});
